import React, { lazy } from 'react';
import {
  Close as CloseIcon,
  QueryBuilder as QueryBuilderIcon,
  CheckOutlined as CheckOutlinedIcon,
} from '@mui/icons-material';

import { useTheme } from '@mui/material';

export const useStatusObject = () => {
  const theme = useTheme();

  return {
    CANCELLED: {
      color: 'warning',
      hexColor: theme.palette.colors.red100,
      hexBgColor: theme.palette.colors.red200,
      title: 'Declined',
      icon: <CloseIcon sx={{ color: theme.palette.colors.red100 }} />,
    },
    AWAITING: {
      color: 'info',
      hexColor: theme.palette.colors.brown,
      hexBgColor: theme.palette.colors.bgOrange,
      title: 'Pending',
      icon: <QueryBuilderIcon sx={{ color: theme.palette.colors.brown }} />,
    },
    ACCEPTED: {
      color: 'success',
      hexColor: theme.palette.colors.green100,
      hexBgColor: theme.palette.colors.bgGreen,
      title: 'Click to accept',
      icon: <CheckOutlinedIcon sx={{ color: theme.palette.colors.green100 }} />,
    },
    APPROVED: {
      color: 'success',
      hexColor: theme.palette.colors.green100,
      hexBgColor: theme.palette.colors.bgGreen,
      title: 'Accepted',
      icon: <CheckOutlinedIcon sx={{ color: theme.palette.colors.green100 }} />,
    },
    MISSED: {
      color: 'error',
      hexColor: theme.palette.colors.gray500,
      hexBgColor: theme.palette.colors.gray300,
      title: 'Missed',
      icon: <CloseIcon sx={{ color: theme.palette.colors.gray500 }} />,
    },
    COMPLETED: {
      color: 'success',
      hexColor: theme.palette.colors.green100,
      hexBgColor: theme.palette.colors.bgGreen,
      title: 'Completed',
      icon: <CheckOutlinedIcon sx={{ color: theme.palette.colors.green100 }} />,
    },
  };
};
